export const APP_STORE_URLS = Object.freeze({
	ANDROID: 'https://play.google.com/store/apps/details?id=com.tigsipay.app',
	IOS: 'https://apps.apple.com/lv/app/tigsipay/id6751570216',
});
